
import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { LoadingState } from "./LoadingState";

interface ScheduleDialogLoadingProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ScheduleDialogLoading: React.FC<ScheduleDialogLoadingProps> = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={(openState) => !openState && onOpenChange(false)} modal>
      <DialogContent 
        className="bg-[#0F141C] border-[#223342] text-white max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Agendar Mentoria</DialogTitle>
        </DialogHeader>
        <LoadingState />
      </DialogContent>
    </Dialog>
  );
};
